import { zoneRoleReducer } from "../reducer/ZoneRoleReducer";

export const reducer = zoneRoleReducer;
